module.exports = __webpack_public_path__ + "as.svg?43207abfbc95987d732e50d476980977";